<template>
	<v-dialog max-width="600px" fullscreen hide-overlay v-model="showDialog">
		<div>
			<div class="header" :style="{ backgroundColor: themeInputColor }">
				<v-btn
					fab
					flat
					icon
					class="top-left-align pa-0 ma-0 z-index--2"
					@click="closeCurrentModal"
				>
					<v-icon color="#FFF">arrow_back</v-icon> </v-btn
				>{{ partnerType }} List
			</div>
			<v-card
				min-height="100vh"
				color="#EDF0F7"
				class="bg"
				v-infinite-scroll="() => loadMoreData(END)"
				infinite-scroll-disabled="loading"
				infinite-scroll-distance="200"
				infinite-scroll-throttle-delay="200"
			>
				<div class="mb-4">
					<div>
						<v-text-field
							label="Phone Number"
							v-model="phoneNo"
							:rules="[validPhoneNoRule]"
							:validate-on-blur="true"
							placeholder="Enter Phone Number"
							class="text-field-wrapper white pt-4"
							prefix="+91"
						></v-text-field>
					</div>
					<div class="d-flex justify-space-around">
						<v-btn
							:loading="loading"
							:color="themeInputColor"
							class="btn white--text"
							@click="fetchJeet11DistributorRetailerListByPhone()"
							>Search</v-btn
						>
						<v-btn
							:disabled="clearDisable"
							color="secondary"
							class="btn"
							@click="
								fetchJeet11DistributorRetailerListByPhone(true)
							"
							>Clear</v-btn
						>
					</div>

					<div v-if="!clearDisable" class="allCenteredChild pt-2">
						<div class="text--center body-1 grey--text">
							Search Result for +91{{ phoneNo }}
						</div>
					</div>
				</div>
				<v-card
					v-for="(item, i) in data.list"
					:key="i"
					class="card-item"
				>
					<div class="d-flex justify-space-between">
						<div class="title theme-text pb-2">
							{{
								item.registeredName || item.retailerName || "-"
							}}
						</div>
						<div
							class="
								caption
								blue-grey--text
								text--lighten-1
								align-right align-end
							"
						>
							Balance
						</div>
					</div>
					<div class="d-flex justify-space-between">
						<div class="blue-grey--text text--lighten-1">
							{{
								item.phoneNo
									? "+91-" + item.phoneNo.toString().slice(2)
									: "-"
							}}
						</div>
						<div class="" v-if="isRummyOptionSelected">
							<div class="green--text text--darken-1 align-right">
								{{ item.gameWalletBalance.toLocaleString() }}
							</div>
						</div>
						<div class="" v-else>
							<div class="green--text text--darken-1 align-right">
								{{ item.walletBalance.toLocaleString() }}
							</div>
						</div>
					</div>
					<v-divider class="my-2"></v-divider>
					<div class="d-flex justify-space-between">
						<v-btn
							class="ma-0"
							flat
							icon
							:disabled="item.status == 1 ? false : false"
							@click.stop="viewRetailerDetails(item)"
							color="#5F7DBA"
						>
							<v-tooltip top :disabled="retailerDetailsDialog">
								<template v-slot:activator="{ on }">
									<v-icon v-on="on">info</v-icon>
								</template>
								<span>View Retailer Details</span>
							</v-tooltip>
						</v-btn>
						<v-btn
							class="ma-0"
							flat
							icon
							:disabled="item.status == 1 ? false : false"
							@click.stop="seeRetailerPassbook(item)"
							color="#5F7DBA"
						>
							<v-tooltip top :disabled="retailerPassbookDialog">
								<template v-slot:activator="{ on }">
									<v-icon v-on="on"
										>account_balance_wallet</v-icon
									>
								</template>
								<span>Passbook</span>
							</v-tooltip>
						</v-btn>
						<v-btn
							class="ma-0"
							flat
							icon
							:disabled="item.status == 1 ? false : false"
							@click.stop="transferCredits(item)"
							color="#5F7DBA"
						>
							<v-tooltip top :disabled="transferCreditsDialog">
								<template v-slot:activator="{ on }">
									<v-icon v-on="on">money</v-icon>
								</template>
								<span>Transfer Credits</span>
							</v-tooltip>
						</v-btn>
						<v-btn
							class="ma-0"
							flat
							icon
							color="#5F7DBA"
							@click.stop="showRetailerUsers(item)"
						>
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-icon v-on="on">person</v-icon>
								</template>
								<span>Show Users</span>
							</v-tooltip>
						</v-btn>
					</div>
				</v-card>
			</v-card>
			<retailer-details
				@CLOSE_MODAL="closeModal"
				model="retailerDetailsDialog"
				v-if="retailerDetailsDialog"
				:themeInputColor="themeInputColor"
				:retailerDetails="selectedRetailerDetails"
			/>
			<passbook-view
				@LOAD_MORE_ROWS="fetchJeet11RetailerTransactionsHistory"
				@CLOSE_MODAL="closeModal"
				:data="
					isRummyOptionSelected
						? rummyPartnerRetailerTransaction
						: jeet11PartnerRetailerTransactions
				"
				:loading="fetchingRetailerTransactions"
				model="retailerPassbookDialog"
				v-if="retailerPassbookDialog"
				:themeInputColor="themeInputColor"
				:retailerDetails="selectedRetailerDetails"
			/>
			<transfer-credits
				@CLOSE_MODAL="closeModal"
				@TRANSFER_CREDITS="transferCreditsToRetailer"
				model="transferCreditsDialog"
				v-if="transferCreditsDialog"
				:forgetMpin="forgetMpin"
				:themeInputColor="themeInputColor"
				:retailerDetails="selectedRetailerDetails"
				:availableCredits="jeet11WalletBalance"
				:loading="pay11Jeet11UserLoading"
				:isRummyOptionSelected="isRummyOptionSelected"
			/>
			<generate-mpin
				@CLOSE_MODAL="closeModal"
				model="generateMpinDialog"
				v-if="generateMpinDialog"
				:themeInputColor="themeInputColor"
			/>
		</div>
	</v-dialog>
</template>
<script>
import { TOP, END } from "@/store/config";
import { mapState } from "vuex";
import infiniteScroll from "vue-infinite-scroll";
import RetailerDetails from "./Jeet11Distributor/retailer-details";
import PassbookView from "@/components/passbook-view";
import {
	FETCH_JEET11_PARTNER_RETAILER_TRANSACTION_HISTORY,
	PAY_JEET11_USER
} from "@/store/action-types";
import TransferCredits from "./Jeet11Distributor/transfer-credits";
import GenerateMPIN from "./GenerateMPIN";
import { _validPhoneNoRule } from "@/utils";
import {
	FETCH_JEET11_PARTNER_WALLET_DETAILS,
	FETCH_RUMMY_PARTNER_RETAILER_TRANSACTION_HISTORY,
	PAY_RUMMY_USER
} from "../store/action-types";

export default {
	name: "ExecutiveRetailerList",
	props: [
		"data",
		"loading",
		"model",
		"partnerType",
		"themeInputColor",
		"isRummyOptionSelected"
	],
	data() {
		return {
			TOP,
			END,
			showDialog: true,
			retailerDetailsDialog: false,
			retailerPassbookDialog: false,
			fetchingRetailerTransactions: false,
			transferCreditsDialog: false,
			pay11Jeet11UserLoading: false,
			generateMpinDialog: false,
			phoneNo: "",
			clearDisable: true,
			validPhoneNoRule: _validPhoneNoRule,
			selectedRetailerDetails: {},
			fetchingProducts: false
		};
	},
	computed: {
		...mapState({
			jeet11PartnerRetailerTransactions: state =>
				state.jeet11.jeet11PartnerRetailerTransactionHistory,
			jeet11WalletBalance: state =>
				state.jeet11.jeet11PartnerDetails.walletBalance || 0,
			rummyPartnerRetailerTransaction: state =>
				state.rummy.rummyPartnerRetailerTransactionHistory
		})
	},
	directives: { infiniteScroll },
	components: {
		"retailer-details": RetailerDetails,
		"passbook-view": PassbookView,
		"transfer-credits": TransferCredits,
		"generate-mpin": GenerateMPIN
	},
	methods: {
		loadMoreData(type) {
			if (!this.data.offset) return;
			this.$emit("LOAD_MORE_ROWS", {
				type
			});
		},
		closeCurrentModal() {
			this.$emit("CLOSE_MODAL", this.model);
		},
		closeModal(payload) {
			this[payload] = false;
			if (payload != this.generateMpinModal)
				this.selectedRetailerDetails = undefined;
		},
		viewRetailerDetails(data) {
			this.selectedRetailerDetails = data;
			this.retailerDetailsDialog = true;
		},
		fetchJeet11RetailerTransactionsHistory(payload) {
			if (!this.fetchingRetailerTransactions) {
				this.fetchingRetailerTransactions = true;
				this.$store
					.dispatch(
						this.isRummyOptionSelected
							? FETCH_RUMMY_PARTNER_RETAILER_TRANSACTION_HISTORY.dispatch
							: FETCH_JEET11_PARTNER_RETAILER_TRANSACTION_HISTORY.dispatch,
						payload
					)
					.catch(() => {})
					.then(() => {
						this.fetchingRetailerTransactions = false;
					});
			}
		},
		seeRetailerPassbook(data) {
			this.selectedRetailerDetails = data;
			this.fetchJeet11RetailerTransactionsHistory({
				TOP,
				retailerId: this.selectedRetailerDetails.userId
			});
			this.retailerPassbookDialog = true;
		},
		forgetMpin() {
			this.generateMpinDialog = true;
		},
		transferCredits(data) {
			this.selectedRetailerDetails = data;
			this.transferCreditsDialog = true;
		},
		transferCreditsToRetailer(payload) {
			if (!this.pay11Jeet11UserLoading) {
				this.pay11Jeet11UserLoading = true;
				this.$store
					.dispatch(
						this.isRummyOptionSelected
							? PAY_RUMMY_USER.dispatch
							: PAY_JEET11_USER.dispatch,
						{
							...payload
						}
					)
					.then(() => {
						this.fetchJeet11WalletDetails();
						this.closeModal("transferCreditsDialog");
					})
					.finally(() => {
						this.pay11Jeet11UserLoading = false;
						this.$emit("LOAD_MORE_ROWS", {
							type: TOP
						});
					});
			}
		},
		showRetailerUsers(retailer) {
			this.$router.push({
				path: "retailer-users",
				query: { id: retailer.userId }
			});
		},
		fetchJeet11DistributorRetailerListByPhone(clear = false) {
			if (!clear) {
				if (this.phoneNo.length !== 10) return;
				this.clearDisable = false;
				this.$emit("LOAD_MORE_ROWS", {
					type: TOP,
					phoneNo: this.phoneNo
				});
			} else {
				this.clearDisable = true;
				this.phoneNo = "";
				this.$emit("LOAD_MORE_ROWS", {
					type: TOP
				});
			}
		},
		fetchJeet11WalletDetails() {
			this.$store
				.dispatch(FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch, {
					isSchemeRequired: true,
					isCardGame: this.isRummyOptionSelected ? 1 : 0
				})
				.catch(() => {})
				.then(() => {});
		}
	}
};
</script>
<style scoped>
.header {
	color: #fff;
	font-size: 18px;
	line-height: 21px;
	text-align: center;
	letter-spacing: 0.004em;
	padding: 18px 0px;
	position: fixed;
	z-index: 1;
	width: 100%;
}
.card-item {
	background: #ffffff;
	box-shadow: 0px 2px 8px rgba(0, 49, 176, 0.05);
	border-radius: 12px;
	padding: 12px 16px;
	margin: 12px 4px;
	font-size: 16px;
}
.bg {
	padding: 5em 1em 1em 1em;
	border-radius: 12px;
}
.theme-text {
	color: #233b5d;
}
.expand-more {
	position: absolute;
	right: 0px;
	top: 24px;
}
.align-right {
	display: flex;
	justify-content: right;
	direction: rtl;
	overflow-wrap: anywhere;
}
</style>
